import { Box, Typography } from "@mui/material";
import usePlans from "../../hooks/usePlans";
import CardComponent from "./Card";
import Loading from "../Loading/Loading";
import { useTranslation } from "react-i18next";
import { typography } from "../../utils/typography";
import { semanticColors } from "../../utils/colors";

export default function Cards({
  onClickCard,
  loadingPayments,
  selectedPlan
}: any) {
  const { t } = useTranslation();
  const { data, loading, error } = usePlans({
    status: "active",
    type: "consumable"
  });

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" mt={5}>
        <Loading />
      </Box>
    );
  }

  if (error || !data) {
    return (
      <Typography
        sx={{ ...typography.body.l, color: semanticColors.text.primary }}
      >
        Não foi possível carregar os pacotes disponíveis.
      </Typography>
    );
  }

  const items = (data as any).items as any[];
  const mostBoughtIdx = Math.floor(items.length / 2);
  const bestPriceIdx = items.length - 1;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "24px",
        width: "100%",
        justifyContent: "center"
      }}
    >
      {items.map((item: any, idx: number) => {
        const badge =
          idx === mostBoughtIdx
            ? t("cmds.mostPurchased")
            : idx === bestPriceIdx
            ? t("cmds.bestPrice")
            : undefined;
        return (
          <CardComponent
            key={item.name}
            onClickCard={onClickCard}
            selectedPlan={selectedPlan}
            loadingPayments={loadingPayments}
            badge={badge}
            {...item}
          />
        );
      })}
    </Box>
  );
}
